import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

export const QuickBooksAuthSuccessPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the main auth page with parameters
    const params = new URLSearchParams(searchParams);
    navigate(`/admin/quickbooks/auth?${params.toString()}`, { replace: true });
  }, [searchParams, navigate]);

  return <div>Redirecting...</div>;
};